import {
	LoadableActivatable,
	LoadableAfterPaint,
	ActivationTriggerType,
} from '@confluence/loadable';
import { SSR_PARTIAL_COMPONENT } from '@confluence/ssr-utilities/entry-points/ssrPartialSuccess';

export const AudioButtonLoaderActivatable = LoadableActivatable({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AudioButton" */ './AudioButton')).AudioButton,
	triggers: [
		{
			type: ActivationTriggerType.HOVER,
		},
	],
	ssrSuccessCheckName: SSR_PARTIAL_COMPONENT.AudioButton,
});

export const AudioButtonLoaderAfterPaint = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-AudioButton" */ './AudioButton')).AudioButton,
});
